import { CARE_MID_COOKIE_NAME } from '@/constants';
import { logger } from '@sentry/utils';
import Cookies from 'universal-cookie';

export enum MemberType {
  SEEKER = 'seeker',
  PROVIDER = 'provider',
}

function useSetCareMidCookie(uuid: string, memberType: MemberType) {
  new Cookies().set(CARE_MID_COOKIE_NAME, uuid, {
    path: '/',
    secure: true,
    domain: `.${window.location.hostname}`,
  });

  logger.info({
    event:
      memberType === MemberType.SEEKER
        ? 'seekerCareMidAvailability'
        : 'providerCareMidAvailability',
    isCareMidCookie: Boolean(new Cookies().get(CARE_MID_COOKIE_NAME)),
    memberUuid: uuid,
  });
}

export default useSetCareMidCookie;
